module.exports = __webpack_public_path__ + "FireAndIce-83ac99811b033740ae04ed797c3364f1.png";